var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"logo-main",attrs:{"to":_vm.url}},[_c('img',{attrs:{"src":_vm.logo}}),_c('p',[_vm._v("财务数字化管理平台")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }